export const USER_LOGIN_ATTEMPT = "USER_LOGIN_ATTEMPT";
export const USER_LOGIN_ATTEMPT_SUCCESS = "USER_LOGIN_ATTEMPT_SUCCESS";
export const USER_LOGIN_ATTEMPT_FAILURE = "USER_LOGIN_ATTEMPT_FAILURE";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
